import ResultsStore from '../../../stores/ResultsStore';

const hotelElementsStore = {
    _hotels: [],
    _prevCount: 0,
    _prevSortMethod: null,
    _listeners: new Set(),

    _onStoreChange: function () {
        const hotels = ResultsStore.getSearchResults()?.hotels;
        this._hotels = hotels || [];
        const count = this._hotels.length;
        const sortMethod = ResultsStore.getSortMethod();

        if (count !== this._prevCount || sortMethod !== this._prevSortMethod) {
            this._prevCount = count;
            this._prevSortMethod = sortMethod;
            this._notifyListeners(count);
        }
    },

    getItem: function (index) {
        return this._hotels[index] || null;
    },

    getCount: function () {
        return this._hotels.length;
    },

    subscribe: function (listener) {
        this._listeners.add(listener);
        return () => {
            this._listeners.delete(listener);
        };
    },

    _notifyListeners: function (count) {
        this._listeners.forEach((listener) => listener(count));
    },
};

ResultsStore.addChangeListener(hotelElementsStore._onStoreChange.bind(hotelElementsStore));

export { hotelElementsStore };
